<msep-alert
  *ngIf="errors$ | async as errors"
  [type]="alertType"
  title="Warning"
>
  <ul>
    <li *ngFor="let error of errors"><span [innerHTML]="error"></span></li>
  </ul>
</msep-alert>
